import { useLayoutEffect, useState } from "react";
import { debounce } from "../../../js/util/timing";
// Thanks to https://stackoverflow.com/a/19014495/13931027 for the help on this hook
export function useWindowSize() {
    const [size, setSize] = useState([null, null]);
    useLayoutEffect(() => {
        const updateSize = debounce(() => {
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            setSize([vw, vh]);
        }, 200, false);
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}
